import { render, staticRenderFns } from "./TemplateTaskForm.vue?vue&type=template&id=08425784&scoped=true&"
import script from "./TemplateTaskForm.vue?vue&type=script&lang=js&"
export * from "./TemplateTaskForm.vue?vue&type=script&lang=js&"
import style0 from "./items.css?vue&type=style&index=0&id=08425784&scoped=true&lang=css&"
import style1 from "./TemplateTaskForm.vue?vue&type=style&index=1&id=08425784&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08425784",
  null
  
)

export default component.exports